/* unplugin-vue-components disabled */import script from "./Redian.vue?vue&type=script&setup=true&lang=js"
export * from "./Redian.vue?vue&type=script&setup=true&lang=js"

import "./Redian.vue?vue&type=style&index=0&id=646c72fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646c72fc"]])

export default __exports__